module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/ministerioconsumo-1.png?006075d6";